import React, { useState, useEffect } from 'react';
import { Modal, Form, Row, Col, Button, Radio } from 'antd';
import config from '@/utils/config';
import { SCALE_SCL90, SCALE_SAS, SCALE_SDS } from './scales'
import styles from './index.less'

const formItemLayout = {
  labelCol: { span: 9 },
  wrapperCol: { span: 15 }
};

const EditModal = ({
  form,
  onCancel,
  onOk,
  currentScale,
  types,
  loading,
  ...other
}) => {
  const { getFieldDecorator, validateFieldsAndScroll } = form;

  const { code } = currentScale

  console.log('currentScale', currentScale)

  const [scaleConfig, setScaleConfig] = useState({})
  const [resultJson, setResultJson] = useState([])

  const handleOk = () => {
    if (types === 'open') {
      onCancel()
      return
    }
    validateFieldsAndScroll((errors, values) => {
      if (errors) return;

      // attachment = attachment && attachment.length > 0 ? attachment[0].url : undefined;
      let newScaleAnswerReqList = []
      Object.keys(values).forEach(key => {
        let newObj = {
          number: parseInt(key),
          result: values[key]
        }
        newScaleAnswerReqList.push(newObj)
      })
      console.log(newScaleAnswerReqList)
      onOk({
        newScaleAnswerReqList,
        taskCode: currentScale.taskCode,
      })
    });
  };

  const modalProps = {
    visible: true,
    title: scaleConfig.name,
    onCancel,
    // onOk: handleOk,
    footer: types === 'open' ? [<span style={{ float: 'left', fontSize: 14 }}>总得分：<span style={{ fontWeight: 500 }}>{currentScale.score}</span>  评估结果：<span style={{ fontWeight: 500 }}>{currentScale.result}</span></span>,
    <Button key="back" onClick={() => onCancel()}>
      关闭
    </Button>,] : (currentScale.score ? [
      <span style={{ float: 'left', fontSize: 14 }}>总得分：<span style={{ fontWeight: 500 }}>{currentScale.score}</span>  评估结果：<span style={{ fontWeight: 500 }}>{currentScale.result}</span></span>,
      <Button key="back" onClick={() => onCancel()}>
        取消
      </Button>,
      <Button key="submit" disabled={types === 'open'} type="primary" loading={loading} onClick={() => handleOk()}>
        确认修改
      </Button>,
    ] : [
        <Button key="back" onClick={() => onCancel()}>
          取消
      </Button>,
        <Button key="submit" disabled={types === 'open'} type="primary" loading={loading} onClick={() => handleOk()}>
          确认修改
      </Button>,
      ]),
    bodyStyle: {
      maxHeight: 400,
      overflowY: 'auto'
    },
    ...other
  };

  useEffect(() => {
    if (code === 'scl90') {
      setScaleConfig(SCALE_SCL90)
    } else if (code === 'sas') {
      setScaleConfig(SCALE_SAS)
    } else if (code === 'sds') {
      setScaleConfig(SCALE_SDS)
    }
    if (currentScale.scaleAnswerRespList) {
      // let result = {}
      // try {
      //   result = JSON.parse(currentScale.resultJson)
      // } catch (d) { }
      console.log(currentScale.scaleAnswerRespList)
      setResultJson([...currentScale.scaleAnswerRespList])

    }

  }, [currentScale])

  resultJson.map(_ => console.log(parseFloat(_.result)))

  return (
    <Modal {...modalProps}>
      <Form>
        <Row gutter={16}>
          <Col span={24}>
            {
              (scaleConfig.items || []).map((item, index) => (
                // <div key={`${index + 1}`} id={`item-${index+1}`}>
                //   <p>{`${index + 1}、${item.text}`}</p>
                //   <Radio.Group>
                //     {item.values.map(i => (
                //         <Radio.Button buttonStyle="d" key={i.score}>
                //             {i.text}
                //         </Radio.Button>
                //     ))}
                //   </Radio.Group>
                // </div>
                <Form.Item className={styles.formItem} label={`${index + 1}、${item.text}`} {...formItemLayout}>
                  {
                    getFieldDecorator(`${index + 1}`, {
                      initialValue: resultJson.length ? parseFloat(resultJson[index].result) : null,
                      rules: [{
                        required: true,
                        message: '必填项'
                      }]
                    })(
                      <Radio.Group buttonStyle="solid" disabled={types === 'open'}>
                        {item.values.map(i => (
                          <Radio.Button key={i.score} value={i.score}>
                            {i.text}
                          </Radio.Button>
                        ))}
                      </Radio.Group>
                    )
                  }
                </Form.Item>
              ))
            }
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default Form.create()(EditModal);
